import { Typography } from "@mui/material";
import CellBox from "../../../../../components/common/table/CellBox";
import React, { useMemo } from "react";
import { ActionModuleInstanceResponse } from "../../../../../types/actionModule/instance/actionModuleInstance";
import { BaseModuleSubtype } from "../../../../../types/actionModule/subtypes/subtype";
import { BaseSubtypeDataModel } from "../../../../../types/actionModule/instance/subtypeData";
import { useTranslation } from "react-i18next";
import { ActionModule } from "../../../../../types/actionModule/actionModule";
import { subtypes } from "../../../../../types/actionModule/actionModuleTypes";

interface Props {
    actionModule: ActionModule;
    subtype: BaseModuleSubtype;
    instance: ActionModuleInstanceResponse;
}

export default function SubtypeSummaryCell(props: Props) {
    const { t } = useTranslation();

    const subtypeData = useMemo(
        () => props.instance.subtypeData.find(d => d.moduleSubtypeId === props.subtype.id),
        [props.instance, props.subtype]
    );

    if (subtypeData === undefined) {
        return <CellBox><Typography>{t("incentivationPage.noData")}</Typography></CellBox>;
    }

    return <CellBox>
        <SubtypeSummary
            subtype={props.subtype}
            subtypeData={subtypeData} />
    </CellBox>;
}

export interface SubtypeSummaryProps {
    subtype: BaseModuleSubtype;
    subtypeData: BaseSubtypeDataModel;
}

function SubtypeSummary(props: SubtypeSummaryProps) {
    const subtypeDefinition = useMemo(
        () => subtypes.find((s) => s.type === props.subtype.subtype),
        [props.subtype.subtype]
    )

    if(!subtypeDefinition) {
        return <></>;
    }
    if(!subtypeDefinition.subtypeDataSummaryView) {
        return <></>;
    }

    return subtypeDefinition.subtypeDataSummaryView({
        subtype: props.subtype,
        subtypeData: props.subtypeData,
    });
}
